import React, { useState, useEffect } from "react";

import {
  Modal,
  Card,
  Table,
  message,
  Form,
  Spin,
  Typography,
  Flex,
} from "antd";
import { Row, Col, Space, Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import ModalSupplier from "../supplier/ModalSupplier.jsx";

import { productColumn } from "./model.js";

import PurchaseOrderService from "../../../service/PurchaseOrder.service";

const poservice = PurchaseOrderService();

export default function ModalpreparePO({ show, close, values }) {
  const [form] = useForm();

  const [listDetail, setListDetail] = useState([]);

  /** Quotation state */
  const [supCode, setsupcode] = useState('');

  const [loading, setLoading] = useState(true);
  const [openSupplier, setOpenSupplier] = useState(false);

  /** handle logic component */
  const handleClose = () => {
    // setTimeout(() => {
      close(false);
    // }, 140);

    //setTimeout( () => close(false), 200 );
  };

  const handleChoosedSupplier = (val) => {
    // console.log(val);
    setsupcode(val.supcode);
    getOrder(val.supcode);
  };

  /** setting initial component */
  const prodcolumns = productColumn();
  const getOrder = (supcode) => {
    setLoading(true);
    poservice
      .prepare(supcode)
      .then((res) => {
        let { detail } = res.data;
        setListDetail(detail);
        // console.log(modalData, data)
        
      })
      .catch((err) => {
        console.warn(err);
        const data = err?.response?.data;
        message.error(data?.message || "error request");
        // setLoading(false);
      })
      .finally(() =>
        setTimeout(() => {
          setLoading(false);
        }, 400)
      );
  };

  const handleConfirm = () => { 
    // console.log(supCode)
    if (supCode === '') throw new message.error("กรุณาเลือกผู้ขาย");
    // const choosed = selected.map( m => m.stcode );
    // const itemsChoose = (itemsData.filter( f => itemsRowKeySelect.includes(f.stcode) && !choosed.includes(f.stcode) )).map( (m, i) => (
    // {
    //     brand_name:m.brand_name,
    //     stcode:m.stcode,
    //     stname:m.stname,
    //     stnameEN:m.stnameEN,
    //     st_add_on:m.st_add_on,
    //     file_name:m.file_name,
    //     price: Number(m?.price || 0),
    //     qty: 1,
    //     unit:m.unit,
    //     discount:0,
    // }));
    
    // const data:{supcode:supCode}
    // values(data,[...listDetail]);

    values({
      list :listDetail,
      supcode:supCode,
    });
    
    setListDetail([]);
    close(false);
}

  useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 400);
  }, []);

  const ButtonModal = (
    <Space direction="horizontal" size="middle" >
        
        <Button onClick={() => handleClose() }>ปิด</Button>
        <Button type='primary' onClick={() => handleConfirm() }>เปิดใบสั่งซื้อสินค้า</Button>
    </Space>
)

  const TitleTable = (
    <Flex className="width-100" align="center" justify="space-between">
      <Typography.Title className="m-0 !text-zinc-800" level={3}>
        รายการสินค้าที่เหลือน้อย
      </Typography.Title>
      <Flex gap={4} align="center">
        {ButtonModal}
      </Flex>
    </Flex>
  );

  return (
    <>
      <Modal
        open={show}
        title="เพิ่มใบสั่งซื้อ"
        onCancel={() => handleClose() } 
        footer={ButtonModal}
        maskClosable={false}
        style={{ top: 20 }}
        width={1600}
        className="modal-preparePO"
      >
        <Spin spinning={loading}>
          <Space
            direction="vertical"
            size="middle"
            style={{ display: "flex", position: "relative" }}
          >
            <Card style={{ backgroundColor: "#f0f0f0" }}>
              <Form form={form} layout="vertical" autoComplete="off">
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Typography.Text className="m-0">
                      เลือกผู้ขาย
                    </Typography.Text>
                    <Space.Compact style={{ width: "100%" }}>
                      <Input
                        readOnly
                        placeholder="เลือก ผู้ขาย"
                        id="supcode-1"
                        value={supCode}
                        className="!bg-white"
                      />
                      <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={() => setOpenSupplier(true)}
                        style={{ minWidth: 40 }}
                      ></Button>
                    </Space.Compact>
                  </Col>
                </Row>
              </Form>
            </Card>
            <Card style={{ minHeight: "60vh", backgroundColor: "#f0f0f0" }}>              
              <Table
                bordered
                title={() => TitleTable}
                dataSource={listDetail}
                rowClassName={() => "editable-row"}
                columns={prodcolumns}
                pagination={false}
                rowKey="stcode"
                scroll={{ x: "max-content" }}
                locale={{
                  emptyText: (
                    <span>No data available, please add some data.</span>
                  ),
                }}
              />
            </Card>
          </Space>
        </Spin>
      </Modal>

      {openSupplier && (
        <ModalSupplier
          show={openSupplier}
          close={() => setOpenSupplier(false)}
          values={(v) => {
            handleChoosedSupplier(v);
          }}
        ></ModalSupplier>
      )}
    </>
  );
}
